module.exports = __webpack_public_path__ + "img/badge_dashboard_pic.b3b65ed4.jpg";